//Local Imports
import { IContactItem, IListItem } from "./interface";
import { ICampaignsName } from "modules/Campaigns/interfaces";

export const serializeList = (jsonData: any): IListItem[] => {
  let lists: IListItem[] = [];

  for (let list of jsonData) {
    lists.push({
      id: list["list_id"] ? list["list_id"] : 0,
      name: list["list_name"] ? list["list_name"] : list["name"],
      isCampaign: list["is_campaign"],
      is_active: "0",
      topContactsThumbnail:
        list["top_contacts_thumbnails"] !== undefined ? list["top_contacts_thumbnails"] : list["thumbnails"],

      totalContacts: list["total_contacts"],
      totalSent: list["total_sent"],
      totalClicks: list["total_clicks"],
      totalDelivered: list["total_delivered"],
      totalOpens: list["total_opens"],
      campaignsCount: list["campaigns_count"] ?? 0,
      lastUpdated: list["last_updated"] !== "" ? list["last_updated"] : "just now",
      count: jsonData.length,
      topContactsPersonIds: list["top_contacts_person_ids"] ? list["top_contacts_person_ids"] : [],
      disabled: false,
      createdBy: list["created_by"],
    } as IListItem);
  }
  return lists;
};
export const serializeContacts = (jsonData: any): IContactItem[] => {
  let contacts: IContactItem[] = [];

  for (let contact of jsonData) {
    contacts.push({
      id: contact["contact_id"],
      name: contact["name"]
        ? contact["name"]?.replaceAll(",", " ")
        : contact["contact_name"]?.replaceAll(",", " "),
      isCampaign: contact["is_campaign"],
      is_active: "0",
      thumbnail: contact["thumbnail"],
      designation: contact["designation"],
      totalSent: contact["total_sent"],
      totalClicks: contact["total_clicks"],
      totalDelivery: contact["total_delivery"],
      totalOpens: contact["total_opens"],
      engagementScore: contact["engagement_score"],
      organization: contact["organization"],
      industry: contact["industry"],
      personality_details: contact["personality_details"],
      personality: contact["personality"],
      color: contact["color"],
      email: contact["contact_email"],
      status: contact["status"],
      disabled: false,
    } as IContactItem);
  }
  return contacts;
};

export const serializeCreateContact = (contact: any): IContactItem => {
  let contact_item = {
    id: contact["contact_id"],
    name: contact["name"] ? contact["name"] : contact["contact_name"],
    isCampaign: contact["is_campaign"],
    is_active: contact["is_active"],
    thumbnail: contact["thumbnail"],
    designation: contact["designation"],
    totalSent: contact["total_sent"],
    totalClicks: contact["total_clicks"],
    totalDelivery: contact["total_delivery"],
    totalOpens: contact["total_opens"],
    engagementScore: contact["engagement_score"],
    organization: contact["organization"],
    industry: contact["industry"],
    personality_details: contact["personality_details"],
    personality: contact["personality"],
    color: contact["color"],
    email: contact["contact_email"],
    status: contact["status"],
    already_exists_in_list: contact["already_exists_in_list"],
  };
  return contact_item;
};

export const serializeCampaigns = (jsonData: any): ICampaignsName[] => {
  let campaigns: ICampaignsName[] = [];

  for (let campaign of jsonData) {
    campaigns.push({
      campaign_id: campaign["id"],
      name: campaign["name"],
    } as ICampaignsName);
  }
  return campaigns;
};
